import React from 'react';
import { FontIcon } from '@fluentui/react';

import styles from './HeaderTitle.module.scss';

function HeaderTitle({text, iconCode}) {
  return (
    <div className={styles.HeaderTitle}>
        <FontIcon iconName={iconCode}></FontIcon>
        {text}
    </div>
  )
}

export default HeaderTitle